module.exports = __webpack_public_path__ + "img/img5-5.cec970c5.jpg";